var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPagebooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1247 31.9587H36.8747M22.1247 41.792H29.4997M9.83301 9.83366V49.167C9.83301 50.471 10.351 51.7215 11.2731 52.6436C12.1951 53.5657 13.4457 54.0837 14.7497 54.0837H44.2497C45.5537 54.0837 46.8042 53.5657 47.7263 52.6436C48.6483 51.7215 49.1663 50.471 49.1663 49.167V20.5077C49.1663 19.8527 49.0353 19.2044 48.7812 18.6007C48.527 17.997 48.1548 17.4502 47.6864 16.9923L36.7714 6.31824C35.8529 5.42011 34.6193 4.91715 33.3347 4.91699H14.7497C13.4457 4.91699 12.1951 5.435 11.2731 6.35705C10.351 7.2791 9.83301 8.52968 9.83301 9.83366Z",
    stroke: "#D38B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.416 4.91699V14.7503C34.416 16.0543 34.934 17.3049 35.8561 18.2269C36.7781 19.149 38.0287 19.667 39.3327 19.667H49.166",
    stroke: "#D38B2E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagebooks);
export default __webpack_public_path__ + "static/media/pagebooks.d6f6da9b7f9f7d88849ceb5cdf7016fa.svg";
export { ForwardRef as ReactComponent };